import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import { ReactComponent as IconBack } from '../../assets/icons/IconBack.svg'

const Dropdown = (props) => {
  const {
    className,
    dark,
    defaultValue,
    fullWidth,
    isDisabled,
    isEmptyOption,
    isValid,
    label,
    options,
    value,
    ...rest
  } = props
  const [showDropdownMenu, setShowDropdownMenu] = useState(false)

  const dropdownMenuSize = options.length <= 10 ? options.length : 10
  const dropdownClasses = cn(['dropdown', className], {
    '-open': showDropdownMenu,
  })

  const toggleDropdownMenu = () => {
    setShowDropdownMenu(!showDropdownMenu)
  }

  const renderDropdownMenu = () => (
    <select
      className="dropdown__value-select"
      defaultValue={defaultValue}
      disabled={isDisabled}
      size={dropdownMenuSize}
      value={value}
      {...rest}
    >
      {isEmptyOption && <option defaultValue="" />}
      {options.map((item, index) => (
        <option key={index} value={item.value || index}>
          {item.label || item}
        </option>
      ))}
    </select>
  )

  return (
    <div className={dropdownClasses} onClick={toggleDropdownMenu}>
      <span className="dropdown__nav-arrow">
        <IconBack className="dropdown__nav-arrow-icon" />
      </span>
      {showDropdownMenu && renderDropdownMenu()}
    </div>
  )
}

Dropdown.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  isEmptyOption: PropTypes.bool,
  isValid: PropTypes.bool,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  fullWidth: PropTypes.bool,
  options: PropTypes.array.isRequired,
  dark: PropTypes.bool,
}

Dropdown.defaultProps = {
  isEmptyOption: false,
}

export default Dropdown
